import { render, staticRenderFns } from "./ChangeAddressPopup.vue?vue&type=template&id=45267946&scoped=true"
import script from "./ChangeAddressPopup.vue?vue&type=script&lang=js"
export * from "./ChangeAddressPopup.vue?vue&type=script&lang=js"
import style0 from "./ChangeAddressPopup.vue?vue&type=style&index=0&id=45267946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45267946",
  null
  
)

export default component.exports